module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/address/postcode.js
// module id = 1379
// module chunks = 0